"use strict";
/**
 * @author by Gor.Hakobyan on 13-May-19.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ReportDataMetaData = /** @class */ (function () {
    function ReportDataMetaData(type, systemName) {
        this.type = type || null;
        this.systemName = systemName || null;
    }
    return ReportDataMetaData;
}());
exports.ReportDataMetaData = ReportDataMetaData;
//# sourceMappingURL=report-data-meta-data.model.js.map